module.exports = __webpack_public_path__ + "assets/webgl/wp_not_ready_yet_color.52a28d7b.jpg";